import React, { useCallback, useContext, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import { Footer, Newsletter } from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner'; // Import the LoadingSpinner component
import Motherhood from './components/Motherhood';
import SingleBlog from './components/SingleBlog';
import ScrollToTop from './components/ui/ScrollToTop';


// Lazy load components
const Home = React.lazy(() => import('./components/Home'));
const TryACall = React.lazy(() => import('./components/TryACall'));
const ProductPage = React.lazy(() => import('./components/ProductPage'));
const Cart = React.lazy(() => import('./Cart'));
const SignUp = React.lazy(() => import('./components/SignUp'));
const CreateAccount = React.lazy(() => import('./components/CreateAccount'));
const MyOrders = React.lazy(() => import('./components/Account/MyOrders'));
const Address = React.lazy(() => import('./components/Account/Address'));
const Checkout = React.lazy(() => import('./components/Checkout'));
const Contact = React.lazy(() => import('./components/Contact'));
const Collection = React.lazy(() => import('./components/Collection'));
const ProfileInfo = React.lazy(() => import('./components/Account/ProfileInfo'));
const Wishlist = React.lazy(() => import('./components/Account/Wishlist'));
const AboutUs = React.lazy(() => import('./components/AboutUs'));
const ShippingPolicy = React.lazy(() => import('./components/ShippingPolicy'));
const ReturnPolicy = React.lazy(() => import('./components/ReturnPolicy'));
const PrivacyPolicy = React.lazy(() => import('./components/PrivacyPolicy'));

function App() {
  const resetLocalStorage = useCallback(() => {
    localStorage.removeItem("filter");
  }, [window.location.pathname]);

  return (
    <Router>
      <ScrollToTop/>
      <Header />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path='/products/:productSlug' element={<ProductPage />} />
          <Route path='/collection/:collectionName' element={<Collection/>} />
          <Route path="/collection/:collectionName/:subCollection" element={<Collection />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/login' element={<SignUp />} />
          <Route path='/register' element={<CreateAccount />} />
          <Route path='/account/personal-info' element={<ProfileInfo />} />
          <Route path='/account/addresses' element={<Address />} />
          <Route path='/account/orders' element={<MyOrders />} />
          <Route path="/account/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/about'  element={<AboutUs/>}/>
          <Route path='/blog'  element={<Motherhood/>}/> 
          <Route path='/blogs/:id'  element={<SingleBlog/>}/>
          <Route path='/shipping-policy'  element={<ShippingPolicy/>}/>  
          <Route path='/return-policy'  element={<ReturnPolicy/>}/> 
          <Route path='/privacy-policy'  element={<PrivacyPolicy/>}/>          
        </Routes>
        <TryACall />
        <Newsletter />
        <Footer />
      </Suspense>
    </Router>
  );
}

export default App;
